// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Qgjj1NLuGSX_WknK0Mi6 { 
  width: 100%;
  height: 100%;
  background-color: #AA555555;
  padding: 20px;
  border-radius: var(--border-radius);
}

.Qgjj1NLuGSX_WknK0Mi6 > button {
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Views/GameOver/index.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".gameOver { \n  width: 100%;\n  height: 100%;\n  background-color: #AA555555;\n  padding: 20px;\n  border-radius: var(--border-radius);\n}\n\n.gameOver > button {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gameOver": `Qgjj1NLuGSX_WknK0Mi6`
};
export default ___CSS_LOADER_EXPORT___;
